import styles from "@/styles/shop-info/day-change-mind.module.scss";
import Link from "next/link";
import Image from "next/image";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;

export default function CompShopWithHappyContent() {
  return (
    <div className={styles["comp-day-change-mind"]}>
      <Image
        className={styles["banner-img"]}
        style={{ display: "block", margin: "0 auto" }}
        src={`${imageDomain}/legal/shop-with-happy-banner.png`}
        alt={"crazy-points-banner"}
        width={800}
        height={139}
      ></Image>
      <div className={`${styles["ask-title"]} padding-top-16`}>
        Shop Online With Over 1,000,000 Happy Customers
      </div>
      <div className={`${styles["answer-desc"]}`}>
        CrazySales.com.au is an &nbsp;
        <Link href="/article/AwardWinning" legacyBehavior>
          <a rel="noopener noreferrer" className={styles["link"]}>
            award-winning online retailer
          </a>
        </Link>
        &nbsp;and is one of Australia&apos;s fastest growing online shopping
        destinations. We have proudly and successfully served over half a
        million online shoppers over a million packages!
      </div>
      <div className={`${styles["answer-desc"]}`}>
        And, thanks to our ultra-low prices, great service, &nbsp;
        <Link href="/article/FastDelivery" legacyBehavior>
          <a rel="noopener noreferrer" className={styles["link"]}>
            fast delivery
          </a>
        </Link>
        &nbsp;and our &nbsp;
        <Link href="/article/EarnCrazyPoints" legacyBehavior>
          <a rel="noopener noreferrer" className={styles["link"]}>
            CrazyPoints reward program
          </a>
        </Link>
        &nbsp;,a full half of our customers come back to buy from us again.
      </div>

      <div className={`${styles["answer-desc"]}`}>
        Who buys at our online store? As you can see from our map, pretty much
        the whole of Australia is shopping online at CrazySales, and we hope
        you&apos;ll enjoy shopping with us too!
      </div>

      <Image
        className={styles["banner-img"]}
        style={{ display: "block", margin: "24px auto" }}
        src={`${imageDomain}/legal/shop-with-happy-pic.png`}
        alt={"crazy-points-banner"}
        width={800}
        height={139}
      ></Image>
    </div>
  );
}
